import * as Sentry from "@sentry/react";

const environment = import.meta.env.MODE;

const breadcrumbDepthLimit = 3;

if (environment !== "development") {
  Sentry.init({
    dsn: "https://f2700ae92c96f464c341e0a7e162c4e4@o10401.ingest.us.sentry.io/4509357475168256",
    normalizeDepth: 6,
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#environment
    environment: import.meta.env.MODE,
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/releases/#setting-a-release
    release: `${import.meta.env.VITE_NAME}@${import.meta.env.VITE_VERSION}`,
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category?.startsWith("ui")) {
        let element = hint?.event.target;
        let message = element.dataset.crumb;

        // Ideally the UI click target is the element tagged for the Sentry breadcrumb.
        if (message) {
          breadcrumb.message = message;
          console.warn(message);
          return breadcrumb;
        }

        // Some MUI components create extra layers of internal elements that separate the UI click 
        // target from the element tagged for the Sentry breadcrumb.  Try to look back through a 
        // number of parent nodes to try and find the element tagged for the Sentry breadcrumb.
        element = element.parentElement;
        let depth = 1;
        while (element && depth <= breadcrumbDepthLimit) {
          let message = element.dataset.crumb;
          if (message) {
            breadcrumb.message = message;
            console.warn(message);
            return breadcrumb;
          }
          element = element.parentElement;
          depth++;
        }
      }
      return breadcrumb;
    }
  });
} else {
  console.warn('Sentry error reporting skipped');
}